import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { IGetSponsors } from "../../../models/admin/sponsors.model";
import SponsorService from "../../../services/admin/sponsors.service";

import { NewSponsorModal } from "../../../components/admin/sponsor/newSponsorModal";
import ExportExcel from "../../../utils/ExportExcel";
import Adminroutes from "../routes";

import Pagination from "react-paginate";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { FaLeaf } from "react-icons/fa";
import is from "date-fns/esm/locale/is/index.js";
import Loading from "../../../components/common/Loading";

export const ExcelDataExport = [
  {
    "S/N": "1",
    "Organization Name": "Naptin",
    "Organization Type": "Public/Private/Individual",
    Address: "....",
    Phone: "080.....",
    Email: "a@gmail.com",
    Website: "naptin.gov.ng",
  },
];

const SponsorsList = () => {
  const navigate = useNavigate();
  const [gender, setGender] = useState<any[]>([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [isSponsor, setIsSponsor] = useState(false);
  const [sponsors, setSponsors] = useState<IGetSponsors[]>();
  const [fileteredSponsor, setFilteredSponsor] = useState<
    IGetSponsors[] | undefined
  >([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [paginationDataSponsor, setPaginationDataSponsor] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 0,
  });

  const handlePageChangeSponsor = (page: any) => {
    setPaginationDataSponsor((prevState) => ({
      ...prevState,
      current_page: page.selected + 1, // Assuming `page.selected` is zero-based
    }));
  };

  const newSponsorModal = async () => {
    setIsSponsor(true);
    onOpen();
  };

  const reloadData = () => {
    setReload(!reload);
  };

  useEffect(() => {
    const maingender = [
      {
        id: "1",
        title: "Technical",
      },
      {
        id: "2",
        title: "Non-Technical",
      },
    ];
    setGender(maingender);
    const url = `?page=${paginationDataSponsor.current_page}`;
    SponsorService.getSponsors(url)
      .then((res) => {
        setSponsors(res.data);
        setFilteredSponsor(res.data);
        setPaginationDataSponsor(res.pagination);
      })
      .catch((err) => err)
      .finally(() => setisLoading(false));
  }, [reload, paginationDataSponsor.current_page]);

  const viewSponsor = async (sponsor_id: string) => {
    navigate(Adminroutes.sponsor.EachSponsorLink(sponsor_id));
  };
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredSponsor(sponsors);
    } else {
      if (sponsors) {
        const filtered = sponsors.filter((each: any) =>
          each.organization_name.toLowerCase().includes(searchTerm)
        );
        setFilteredSponsor(filtered);
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>

          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              pb="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Sponsors List
                </Box>
                <Flex>
                  <Button
                    mr={["1px", "1px", "3px", "3px"]}
                    borderRadius={2}
                    colorScheme="red"
                    size="sm"
                    fontSize={12}
                    onClick={() => {
                      newSponsorModal();
                    }}
                  >
                    Upload Sponsors
                  </Button>
                  <ExportExcel
                    title="Download Template"
                    excelData={ExcelDataExport}
                    fileName={"Sponsor Batch Template"}
                  />
                </Flex>
              </Flex>
              <Flex py="15px" justifyContent="">
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width={["100%", "100%", "50%", "30%"]}
                >
                  <Input
                    height="40px"
                    placeholder="Search for sponsors"
                    fontSize={12}
                    size="sm"
                    onChange={(e) => handleSearchChange(e)}
                  />

                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>
              </Flex>
              <Box width="100%">
                <TableContainer>
                  <Table variant="simple">
                    <Thead mb="10px">
                      <Tr
                        pb="10px"
                        fontSize="14px"
                        borderBottom="1px solid"
                        borderColor="#D5D5D5"
                      >
                        <Th textTransform="none">Sponsors</Th>
                        <Th textTransform="none">Email</Th>
                        <Th textTransform="none">Sponsors ID</Th>

                        <Th textTransform="none">Website</Th>
                        <Th textTransform="none">Status</Th>
                        <Th textTransform="none">Options</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {!isLoading &&
                      fileteredSponsor &&
                      fileteredSponsor?.length > 0
                        ? fileteredSponsor.map((each, index) => (
                            <Tr
                              key={index}
                              bg="white"
                              fontSize="14px"
                              onClick={() => {
                                viewSponsor(each.uuid);
                              }}
                            >
                              <Td>
                                <Text textTransform="capitalize">
                                  {each.organization_name.toLowerCase()}
                                </Text>
                              </Td>
                              <Td>
                                <Text>{each.email}</Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text>{each.code}</Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text>{each.website}</Text>
                              </Td>

                              <Td>
                                {each.status == 1 ? (
                                  <Text>In Progress</Text>
                                ) : (
                                  <Text>Suspended</Text>
                                )}
                              </Td>
                              <Td>
                                <HStack>
                                  <Center
                                    border="1px solid"
                                    borderRadius="10px"
                                    borderColor="#E5E5E5"
                                    width="30px"
                                    height="30px"
                                  >
                                    <RiEyeLine />
                                  </Center>
                                  <Center
                                    border="1px solid"
                                    borderRadius="10px"
                                    borderColor="#E5E5E5"
                                    width="30px"
                                    height="30px"
                                  >
                                    <HiOutlinePencil />
                                  </Center>
                                </HStack>
                              </Td>
                            </Tr>
                          ))
                        : !isLoading && (
                            <div>No sponsors yet, add a sponsor</div>
                          )}
                    </Tbody>
                  </Table>
                </TableContainer>
                {paginationDataSponsor.total > 0 && (
                  <Box pb="1rem">
                    <Pagination
                      breakLabel="..."
                      nextLabel={<ArrowRightIcon style={{ fontSize: 18 }} />}
                      onPageChange={handlePageChangeSponsor}
                      pageRangeDisplayed={5}
                      pageCount={paginationDataSponsor.last_page}
                      previousLabel={<ArrowLeftIcon style={{ fontSize: 18 }} />}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="active"
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          {isSponsor && (
            <Portal>
              {" "}
              <NewSponsorModal
                isOpen={isOpen}
                onClosed={onClose}
                isSponsor={isSponsor}
                reload={reloadData}
                isBatch={true}
              />{" "}
            </Portal>
          )}
        </Flex>
      )}
    </>
  );
};

export default SponsorsList;
